
import { computed, defineComponent, ref, Ref } from 'vue';
import breakpointsState from '@/core/responsive/breakpoints/breakpoints-state.observable';

export default defineComponent({
    name: 'VideoPlayer',
    props: {
        url: {
            required: true,
            type: String,
        },
        poster: {
            required: false,
            default: undefined,
            type: String,
        },
        title: { required: false, type: String, default: '' },
        autoFitVideoToAspectRatio: { type: Boolean, default: false, required: false },

        /* Can take a single aspect ratio number, or an object with a number pr. breakpoint. If a 'default' is provided is will be used when no breakpoint is active:
           {
                xs: 16/9,
                min-sm,max-md: 4/3
                default: 1/2
           }
        */
        aspectRatio: { type: [Number, Object], default: 16 / 9 },
    },
    setup(props, { emit }) {
        const videoRef: Ref<HTMLVideoElement | null> = ref(null);

        const activeAspectRatio = computed(() => {
            if (typeof props.aspectRatio === 'number') {
                return props.aspectRatio;
            }

            // Else - object with aspect-ratio pr. breakpoint-def.

            // Find first active breakpoint-def
            const activeBpDef = Object.keys(props.aspectRatio).find((bpDef) => breakpointsState.isBreakpointActive(bpDef));
            // Use active or default
            const result = activeBpDef ? props.aspectRatio[activeBpDef] : props.aspectRatio.default;
            if (!result) {
                throw new Error('Provide a breakpoint-definition for all cases or a default');
            }
            return result;
        });

        const style = computed(() => {
            const padding = `${(100 / activeAspectRatio.value).toFixed(2)}%`;
            return { paddingTop: padding };
        });

        return {
            videoRef,
            style,
        };
    },
});
